// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__EFda9","signatureBlock":"Footer_signatureBlock__3_1xo","signature":"Footer_signature__2O7bA"};